import { getNodeConnectionsCount } from "../modules/nexusFuncs"

const angle030 = Math.PI / 6
const angle045 = Math.PI / 4
const angle270 = 1.5 * Math.PI

export const setNodeAngles = ({ nodes, levelCount, tense }) => {
  let level1Index = 0
  let level2Index = 0
  let previousl1NodeIndex = 0

  // console.log("nodes: ", nodes)

  nodes.forEach(node => { // hub node
    switch (node.level) {
      case 1:

        switch (levelCount[1]) {
          case 1:
            node.angle = angle270
            break

          case 2:
            node.angle = level1Index === 0 ? -angle045 : angle045
            break

          default:
            node.angle = Math.PI + (level1Index * 2 * Math.PI / levelCount[1])
            // console.log("node.angle=" + (node.angle * 180 / Math.PI).toFixed(0) + " degrees")
            break
        }

        ++level1Index
        break

      case 2:
        const l1NodeIndex = nodes.findIndex(element => element.id === node.lConnectId)
        const l1Node = nodes[l1NodeIndex]

        if (l1NodeIndex !== previousl1NodeIndex) level2Index = 0

        // find how many level 2 nodes are connected to its level 1 parent
        /* if (!l1Node || !l1Node.connectionCounts) {
          console.log("this code")
          node.angle = 0
          if (!l1Node) console.error("l1Node not available: ", l1Node)
          if (!l1Node.connectionCounts) console.error("l1Node.connectionCounts: ", l1Node.connectionCounts)
        } else { */

        const nodeL2Count = getNodeConnectionsCount({ node: l1Node, tense }) - 1
        // TODO: Check if we need '-1' above as below we have 'nodeL2Count - 1'
        // console.log("l1Node: ", l1Node.id + ",  L2count = " + nodeL2Count)
        if (nodeL2Count === 1)
          node.angle = l1Node.angle + angle030 // 1 level 2 node, at 30 degrees
        else { // 2 or more level 2 nodes
          // distribute angle evenly around angle of level 1 node
          node.angle = l1Node.angle +
            (((level2Index / (nodeL2Count - 1)) - 0.5) * angle045) // spread over 45 degrees
          // console.log("node.angle=" + (node.angle * 180 / Math.PI).toFixed(0) + " degrees")
          ++level2Index
        }
        // }
        previousl1NodeIndex = l1NodeIndex
        break

      case 0:
      default:
        node.angle = null
        break
    }
  })
}

export default setNodeAngles
